export default __webpack_public_path__ + "media/images/onglet1-c9835261ceb923719bc01eed87d359c6.png";